//@ts-check
import {Button} from '@/components-v2/atoms/Button/Button'
import {Tag} from '@/components-v2/atoms/Tag/Tag'
import {Text} from '@/components-v2/atoms/Text/Text'
import {TAG_COLOR} from '@/utils/constants/colors'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useNavigate} from 'react-router-dom'
import {useProductReview} from '../context/ProductReviewContext'

const STATUS_TO_TAG_COLOR = {
  active: TAG_COLOR.GREEN,
  draft: TAG_COLOR.BLUE,
}

export const ProductReviewHeader = () => {
  const navigate = useNavigate()
  const {
    productData: {baseData},
    isLoading,
  } = useProductReview()
  const statusKey = baseData?.status?.toLowerCase()
  const tagColor = STATUS_TO_TAG_COLOR[statusKey] ?? TAG_COLOR.GRAY
  const productInfoItems = [
    {label: 'Product ID', value: baseData?.productId},
    {label: 'GTIN', value: baseData?.gtin},
    {label: 'Parent ID', value: baseData?.parentId},
  ]

  return (
    <div className="flex flex-col gap-3">
      <Button
        text="Back"
        size="medium"
        iconLeading="arrow_back_ios"
        variant="tertiary"
        onClick={() => navigate(ROUTES.PRODUCTS_LIST)}
      />
      <div className="mt-4 flex flex-row items-center gap-6">
        <Text headingLevel={3} variant="bold">
          {isLoading ? 'Loading...' : baseData?.name}
        </Text>
        <Tag text={baseData?.status} color={tagColor} />
      </div>
      <div className="flex items-center divide-x divide-gray-300">
        {productInfoItems.map(item => (
          <div key={item.label} className="px-4 first:pl-0 last:pr-0">
            <Text size="small" variant="bold">
              {item.label}: {item.value || '-'}
            </Text>
          </div>
        ))}
      </div>
    </div>
  )
}
